import React, { Component } from "react";
import DATEPICKER_OR from "../../../../common/custom-form/custom-date-picker.component";
import { InputField } from "../../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../../common/custom-form/select-filter.component";
import { Button } from "react-bootstrap";
import ButtonIcon from "../../../../button";
import { TextArea } from "../../../../common/custom-form/custom-textarea.component";
export class ContractDetailsManagement extends Component {
    constructor(props){
        super(props);
        this.state={
            inputValue: "",
            filterSelected: "", 
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
        }
    }
    render() {
        return(
            <>
                <h1>Contract Dates</h1>
                        <div className="manage-order-container">
                            <div className="manage-order-detail">
                                <InputField label="Contract ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <SelectField label="Please select Vendor"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                                <InputField label="Currency" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="Contract Name" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <SelectField label="Please select Service Type"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                                <InputField label="Utilization" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />                                
                                <SelectField label="Please Select Region"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>   
                                <TextArea customClass="grid-item-span-2" label="Field Label" inputValue={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <div></div>
                                <SelectField label="Please Select Country"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                              
                            </div>
                        </div>
                        <h1>Contract Dates</h1>
                        <div className="manage-order-container">                          
                            <div className="manage-order-detail">
                                <SelectField label="Please select Vendor"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                                <InputField label="GL CODE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <DATEPICKER_OR label="REQUESTED DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                                <DATEPICKER_OR label="REQUESTED DATE" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                                <SelectField label="Please select Vendor"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                                <div className="finace-upload-container">
                                    <ButtonIcon onClick={()=>alert("click")} iconLeft="cloud-arrow-up" iconSize="17px" customClassName="header-filter-button" labelName="Choose File"/> 
                                    <span className="invoice-file-label">No File Selected</span>
                                </div>
                               
                            </div>

                        </div>  
                        <h1>Contract Commitments</h1>
                        <div className="manage-order-container">                            
                            <div className="manage-order-detail">      
                                <InputField label="Term Commitment Volume" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <InputField label="Annual Commitment Volume" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />  
                                <InputField label="Sub Commitment" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />  
                                <InputField label="Escalating Commitment" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />  
                                <InputField label="Exclusively" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />   
                                <div></div>
                                <div className="horizontal-separator grid-item-column-span-3"></div>
                                <SelectField label="Number of Levels"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                  
                            </div>
                        </div>                                           
                                         
            </>
        )
    }
}